import classNames from "classnames";
import {
  ButtonHTMLAttributes,
  CSSProperties,
  FC,
  MouseEventHandler,
  ReactNode,
} from "react";
import styles from "./button.module.scss";

type ButtonProps = {
  onClick?: MouseEventHandler;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
  component?: any;
  style?: CSSProperties;
  variant?: "gradient" | "outlined" | "pink" | "blue";
  icon?: ReactNode;
  children: ReactNode;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const Button: FC<ButtonProps> = ({
  onClick,
  className,
  component,
  disabled = false,
  isLoading = false,
  style,
  variant = "gradient",
  icon,
  children,
  ...props
}) => {
  return (
    <button
      className={classNames(
        styles.button,
        styles[`button__${variant}`],
        className,
        { [styles.disabled]: disabled || isLoading }
      )}
      style={style}
      disabled={disabled || isLoading}
      onClick={onClick}
      {...props}
    >
      {icon && <span className={styles.button__icon}>{icon}</span>}
      {children}
    </button>
  );
};

export default Button;
